export default (theme) => ({
    root: {
        height: '100% !important',
        padding: '8px',
        boxSizing: 'border-box',
        overflowY: 'auto',
        ...theme.utils.scrollbar,

        '& .grid-stack': {
            '&.gs-1 > .grid-stack-item': { width: '100%' },

            '&.gs-2 > .grid-stack-item[gs-x="1"]': { left: '50%' },

            '&.gs-2 > .grid-stack-item': { width: '50%' },
            '&.gs-2 > .grid-stack-item[gs-w="2"]': { width: '100%' },

            '&.gs-3 > .grid-stack-item[gs-x="1"]': { left: '33.33%' },
            '&.gs-3 > .grid-stack-item[gs-x="2"]': { left: '66.67%' },

            '&.gs-3 > .grid-stack-item': { width: '33.33%' },
            '&.gs-3 > .grid-stack-item[gs-w="2"]': { width: '66.67%' },
            '&.gs-3 > .grid-stack-item[gs-w="3"]': { width: '100%' },

            '&.gs-4 > .grid-stack-item[gs-x="1"]': { left: '25%' },
            '&.gs-4 > .grid-stack-item[gs-x="2"]': { left: '50%' },
            '&.gs-4 > .grid-stack-item[gs-x="3"]': { left: '75%' },

            '&.gs-4 > .grid-stack-item': { width: '25%' },
            '&.gs-4 > .grid-stack-item[gs-w="2"]': { width: '50%' },
            '&.gs-4 > .grid-stack-item[gs-w="3"]': { width: '75%' },
            '&.gs-4 > .grid-stack-item[gs-w="4"]': { width: '100%' },

            '& .grid-stack-item': {
                '&:hover': {
                    '& .ui-resizable-handle': {
                        display: 'block',
                    },
                },
                '& .ui-resizable-handle': {
                    zIndex: '0 !important',
                    display: 'none',
                },

                '&.grid-stack-placeholder': {
                    '& > div': {
                        backgroundColor: theme.colors.semantic.infoCustom50,
                        borderRadius: '8px',
                    },
                },

                '& > .ui-resizable-se': {
                    right: '12px',
                    bottom: '12px',
                },
            },

            '& .grid-stack-item-content': {
                overflow: 'hidden',
            },
        },
    },
    gridItem: {
        borderRadius: '8px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        boxSizing: 'border-box',
        cursor: 'grab',
        backgroundColor: theme.colors.primary.white,
    },
    disabledDrag: {
        cursor: 'default',
    },
});
